/**
 * @generated SignedSource<<cde1aed11301afd27964da1dc0ce3d15>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceGraphQLDefaultTitleEmoji {
  LIVE_PAGE_DEFAULT = "LIVE_PAGE_DEFAULT",
  NONE = "NONE",
}
export interface ConfluenceUpdateDefaultTitleEmojiInput {
  contentId: Scalars["ID"]["input"];
  defaultTitleEmoji: ConfluenceGraphQLDefaultTitleEmoji;
}
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_AdminAnnouncementBannerMutationErrorExtension =
  {
    __typename?: "AdminAnnouncementBannerMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ConfluenceUpdatePdfExportConfigurationMutationErrorExtension =
  {
    __typename?: "ConfluenceUpdatePdfExportConfigurationMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ConfluenceUpdateSiteConfigurationMutationErrorExtension =
  {
    __typename?: "ConfluenceUpdateSiteConfigurationMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_GenericMutationErrorExtension =
  {
    __typename?: "GenericMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_PatchCommentsSummaryMutationErrorExtension =
  {
    __typename?: "PatchCommentsSummaryMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ReopenCommentsMutationErrorExtension =
  {
    __typename?: "ReopenCommentsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ResolveCommentsMutationErrorExtension =
  {
    __typename?: "ResolveCommentsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ResolveRestrictionsForSubjectMutationErrorExtension =
  {
    __typename?: "ResolveRestrictionsForSubjectMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_UpdateExCoSpacePermissionsMutationErrorExtension =
  {
    __typename?: "UpdateExCoSpacePermissionsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_UpdateSpacePermissionsMutationErrorExtension =
  {
    __typename?: "UpdateSpacePermissionsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions =

    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_AdminAnnouncementBannerMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ConfluenceUpdatePdfExportConfigurationMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ConfluenceUpdateSiteConfigurationMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_GenericMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_PatchCommentsSummaryMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ReopenCommentsMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ResolveCommentsMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_ResolveRestrictionsForSubjectMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_UpdateExCoSpacePermissionsMutationErrorExtension
    | EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions_UpdateSpacePermissionsMutationErrorExtension;
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError =
  {
    __typename?: "MutationError";
    message: string | null;
    extensions: Array<EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError_extensions | null> | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload =
  {
    __typename?: "ConfluenceUpdateDefaultTitleEmojiPayload";
    contentId: string;
    success: boolean;
    errors: Array<EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload_errors_MutationError> | null;
  };
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation_Mutation = {
  __typename?: "Mutation";
  confluence_updateDefaultTitleEmoji: EmojiTitleButtonUpdateDefaultTitleEmojiMutation_confluence_updateDefaultTitleEmoji_ConfluenceUpdateDefaultTitleEmojiPayload;
};
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutationVariables = Exact<{
  cloudId: Scalars["ID"]["input"];
  input: ConfluenceUpdateDefaultTitleEmojiInput;
}>;
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation =
  EmojiTitleButtonUpdateDefaultTitleEmojiMutation_Mutation;
